import { CommandJob, Job } from "~/components/build/Show/lib/types";
import Emojify from "~/components/shared/Emojify";
import { SortFn } from ".";
import { ParallelJobIndex } from "~/components/build/Show/components/ParallelJobIndex";
import { ParallelCommandJob } from "~/components/build/Show/lib/types/CommandJob";

const EMOJI_REGEX =
  /[\p{Emoji}\p{Emoji_Presentation}\p{Emoji_Modifier}\p{Emoji_Modifier_Base}\p{Emoji_Component}]/gu;

const RetriedBadge = ({ job }: { job: CommandJob }) => {
  if (!job.retriedInJobUuid) {
    return null;
  }

  return (
    <span
      className="text-charcoal-300 ml-1 inline-block rounded-[3px] bg-gray-100 px-0.5 text-xs"
      data-testid="retried-badge"
    >
      Retried
    </span>
  );
};

export function Label({ job }: { job: Job }) {
  let label = job.name || "";

  if (!label && job.type === "trigger") {
    const pipeline = job.triggerProject?.name || job.triggerProjectSlug;
    label = `Trigger build on ${pipeline}`;
  }

  const isParallelCommandJob =
    job.type === "script" && (job as ParallelCommandJob).parallelGroupTotal >= 1;

  return (
    <div className="flex items-center gap-1" data-testid="job-table-row-label">
      {isParallelCommandJob && <ParallelJobIndex job={job as ParallelCommandJob} />}

      <Emojify text={label} className="max-w-full truncate font-medium" />

      {job.type === "script" && <RetriedBadge job={job} />}
    </div>
  );
}

/* eslint-disable id-length */
export const sortByLabel: SortFn = (direction) => (a, b) => {
  const aLabel = a.name || "";
  const bLabel = b.name || "";

  const aLabelForSorting = aLabel.replace(EMOJI_REGEX, "").trim();
  const bLabelForSorting = bLabel.replace(EMOJI_REGEX, "").trim();

  if (direction === "asc") {
    return aLabelForSorting.localeCompare(bLabelForSorting);
  }
  return bLabelForSorting.localeCompare(aLabelForSorting);
};
